import React from 'react';
import 'antd/dist/antd.css';
import { Avatar } from 'antd';
import PropTypes from 'prop-types';

function stringToHslColor(str, s, l) {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = hash % 360;
  return `hsl(${h}, ${s}%, ${l}%)`;
}

export default function UserAvatar({ user, size }) {
  return user?.image ? (
    <Avatar
      src={user?.image}
      size={ size }
      // size={64}
      gap={2}
    />
  ) : (
    <Avatar
      style={{ backgroundColor: stringToHslColor(user?.name, 50, 50), verticalAlign: 'middle' }}
      size={ size }
      // size={64}
      gap={2}
    >
      {user?.name?.substring(0, 3).toUpperCase()}
    </Avatar>
  );
}

UserAvatar.propTypes = {
  user: PropTypes.object.isRequired,
  size: PropTypes.string,
};

UserAvatar.defaultProps = {
  size: 'default',
};
